import SocialIcon from '../../components/SocialIcon';

export default function About() {
  const techs = [
    'HTML',
    'CSS',
    'JavaScript',
    'React',
    'Tailwind CSS',
    'Firebase',
  ];

  return (
    <section className="animate-zoomPage lg:flex font-inter ">
      <div className="about-card mb-5 lg:mb-0 lg:mr-7 lg:flex-1">
        <h3 className="text-center text-ash-200 text-xl md:text-2xl font-bold mb-4">
          Okechukwu Chidera
        </h3>

        <ul className="font-monoBody flex flex-wrap text-accent mb-2 md:text-xl">
          <span className="text-gold mr-2">Stack: </span>
          {techs.map((tech, i) => (
            <li key={i} className="mr-1 stack">
              {tech}
            </li>
          ))}
        </ul>

        <p className="text-ash-100 text-base mb-4 md:text-xl">
          I’m a frontend developer, who builds responsive and SEO optimized web
          applications with HTML, CSS, JavaScript and frameworks such as React
          and Tailwind CSS.
        </p>
        <SocialIcon />
      </div>

      <div className="about-card lg:flex-[1.5]">
        <h2 className="text-gold text-center text-2xl md:text-3xl font-semibold mb-5">
          About Me
        </h2>

        <p className="text-ash-100 text-base mb-4 md:text-xl">
          Hello world, I'm a multi-talented individual whose passion and
          expertise have taken them on an inspiring journey across diverse
          domains.
        </p>

        <p className="text-ash-100 text-base mb-4 md:text-xl">
          As a Front End Developer, Odeco brings websites to life with an
          enchanting blend of code and design. With an innate understanding of
          user experience I can seamlessly merge form and function, transforming
          mere websites into captivating online experiences.
        </p>

        <div>
          <a
            href="mailto:odecoglobal@gmail.com"
            className="btn-link"
            target="_blank"
          >
            Contact Me
          </a>
        </div>
      </div>
    </section>
  );
}
